import styled from "@emotion/styled";
import { LdLabel } from "@liquid/react";

import { pxToRem } from "@src/utils";

const StyledRadioButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(10)};
  align-items: start;
`;

const StyledRequired = styled(LdLabel)`
  gap: ${pxToRem(3)};
  :after {
    content: " *";
  }
`;

export { StyledRadioButtonWrapper, StyledRequired };
